import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-timeline-workshop',
    templateUrl: './timeline-workshop.component.html',
    styleUrls: ['./timeline-workshop.component.scss'],
    standalone: false
})
export class TimelineWorkshopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
